import React, { useEffect, useState, useFocusEffect } from "react";

import {
  Row,
  Col,
  Modal,
  Container,
  Card,
  Button,
  Overlay,
} from "react-bootstrap";
import Stepper from "react-stepper-horizontal";
import {
  //BrowserRouter as
  // Router, Route,
  Link,
} from "react-router-dom";
// import "../../Common/Common.css";
import PersonalDetails from "../ProfileUpdate/Components/PersonalDetails";
import OrganizationDetails from "../ProfileUpdate/Components/OrganizationDetails";
import UploadDocument from "../ProfileUpdate/Components/UploadDocument";
// import InsuranceDetails from "./components/InsuranceDetails";
import "./style.css";
function ProfileUpdate({ value, ...props }) {
  const [steps, setSteps] = useState([
    { title: "Personal Details" },
    { title: "Organization Details" },
    // { title: "Upload Document" },
  ]);
  const [currentstep, setCurrentStep] = useState(0);
  const [formParams, setFormParams] = useState(null);
  const [showProf, setshowProf] = useState(true);
  const [show, setShow] = useState(true);
  const handleClose = () => setShow(false);

  useEffect(() => {
    setshowProf(true);
  }, []);

  const settingData = (values) => {
    setFormParams({
      ...formParams,
      ...values,
    });
  };
  const clickHandler = (tab, values = null) => {
    
    setCurrentStep(tab);
    if (values) {
      settingData(values);
    }
  };

  const submitForm = (values) => {
    let params = { ...formParams, ...values };
   
    props.addshipperprofile(params);
  };

  const renderSection = () => {
    switch (currentstep) {
      case 0:
        return (
          <PersonalDetails
            clickHandler={clickHandler}
            fetchCountry={props.fetchCountry}
            countryprofdetailList={props.countryprofdetailList}
            item={formParams}
            fetchregion={props.fetchregion}
            regionList={props.regionList}
            fetchlocation={props.fetchlocation}
            locationList={props.locationList}
            addshipperImg={props.addshipperImg}
          />
        );

      case 1:
        return (
          <OrganizationDetails clickHandler={clickHandler} item={formParams}  submitForm={submitForm} />
        );

      // case 2:
      //   return (
      //     <UploadDocument
      //       clickHandler={clickHandler}
      //       item={props.formParams}
      //       submitForm={submitForm}
      //     />
      //   );

      default:
        return null;
    }
  };

  return (
    <div className="updateprofilediv">
      <div>
        <Modal
          show={show}
          onHide={handleClose}
          size="md"
          backdrop="static"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          style={{ backgroundColor: "rgba(0, 0, 0, 0.54)" }}
        >
          <Modal.Body style={{ textAlign: "center" }}>
            <h4 className="profcomhd">
              Please complete your profile to continue
            </h4>
            <Row style={{ marginTop: "30px", marginBottom: "20px" }}>
              <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                <Link to="/login" onClick={() => window.scrollTo(0, 0)}>
                  <Button variant="danger" className="cmnProfCnclBtn">
                    LOG OUT
                  </Button>
                </Link>
              </Col>
              <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                <Button
                  variant="success"
                  className="cmnProfOkBtn"
                  onClick={handleClose}
                >
                  OK
                </Button>
              </Col>
            </Row>
          </Modal.Body>
        </Modal>
      </div>

      <Card className="updateprofilecard">
        <div className="">
          <Link to="/login" onClick={() => window.scrollTo(0, 0)}>
            <i className="fa fa-times fa-lg closeiconview " />
          </Link>
        </div>
        <Card.Body>
          <Container className="licensee-modal ">
            <Row>
              {" "}
              <div className="step-cont">
                <Stepper
                  className="step-head"
                  steps={steps}
                  activeStep={currentstep}
                  activeColor="#05334c"
                  completeColor="rgb(66, 186, 150)"
                  completeTitleColor="rgb(66, 186, 150)"
                  completeBarColor="rgb(66, 186, 150)"
                  titleFontSize={20}
                  activeTitleColor="#05334c"
                />
              </div>
            </Row>
            <hr />
            <div>{renderSection()}</div>
          </Container>
        </Card.Body>
      </Card>
    </div>
  );
}

export default ProfileUpdate;
